export const BACK = "back";
export const CLOSE = "close";
export const INVALID_DEVICE_LOCK_CODE = "Invalid device lock code.";
export const LIMIT_REACHED = "Device unlock requests limit reached.";
